import React, { useRef, useState } from 'react';
import { BookingState } from '../../modules/booking-state/BookingState';
import { VehicleDetailsPageContext } from './VehicleDetailsPageContext';
import { VehicleDetailsPageFormData } from './VehicleDetailsPageFormData';
import { useViewProvider } from '../../modules/contexts/view-provider-context/ViewProvider';
import { withPageContext } from '../../modules/contexts/WithPageContext';
import { Wizard, WizardNavigate } from '../../modules/wizard/Wizard';
import { Steps } from '../../modules/wizard/Steps';
import { FormRef } from '../../modules/forms/Form';
import { useBookingContext } from '../../modules/booking-state/UseBookingContext';
import { VehicleDetailsPageViewProps } from './VehicleDetailsPageViewProps';

function ContextAccessor({ vehicleDetails, registrationNumber }: BookingState): VehicleDetailsPageContext | null {
  if (!vehicleDetails) {
    return null;
  }

  return {
    registrationNumber,
    vehicleDetails,
  };
}

export const VehicleDetailsPage = withPageContext(ContextAccessor, ({ pageContext }) => {
  const viewProvider = useViewProvider();
  const [bookingState] = useBookingContext();
  const [vehicleImageDisplayed, setVehicleImageDisplayed] = useState(true);
  const formRef = useRef<FormRef<VehicleDetailsPageFormData>>(null);
  const servicePlan = pageContext.vehicleDetails.plans.find(plan =>
    plan.planType === 'Maintenance' || plan.planType === 'Service'
  );

  const [isLoading, setLoading] = useState(true);

  React.useEffect(() => {
    if (pageContext && pageContext.vehicleDetails) {
      setLoading(false);
    }
  }, [pageContext]);

  const formData: VehicleDetailsPageFormData = {
    vin: pageContext.vehicleDetails.vin,
    registrationNumber: pageContext.vehicleDetails.registrationNumber ?? 'N/A',
    servicePlan: servicePlan ? servicePlan.planStatus : 'None',
    warrantyPlan: pageContext.vehicleDetails.plans.find(plan => plan.planType === 'Warranty')?.planStatus ?? 'Expired',
  };

  const onNext: WizardNavigate = (nextStep) => {
    formRef.current!.submit(() => {
      nextStep(bookingState);
    });
  };
  const onPrevious: WizardNavigate = (previousStep) => {
    previousStep(bookingState);
  };

  const viewProps: VehicleDetailsPageViewProps = {
    vehicleDetails: pageContext.vehicleDetails,
    formData,
    formRef,
    vehicleImageDisplayed,
    setVehicleImageDisplayed,
  };

  return (
    <Wizard currentStep={Steps.YourVehicle} onNext={onNext} onPrevious={onPrevious} disabled={isLoading}>
      {viewProvider.renderVehicleDetailsPage(viewProps)}
    </Wizard>
  );
});
